"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteDataSource = void 0;
const react_1 = require("react");
const fdr_lib_apollo_query_1 = require("@hotelplan/fdr.lib.apollo.query");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_regular_fusion_fdr_autocomplete_context_1 = require("@hotelplan/fdr.regular.fusion.fdr-autocomplete-context");
function FdrAutocompleteDataSource(props) {
    var _a;
    const { queryDocument, dataMapper, variablesMapper, suggestionMapper, minQueryLength = 1, onCompleted, onError, } = props;
    const ctx = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    const currentVars = (0, libs_hooks_react_1.useSelfUpdatingRef)(variablesMapper({
        query: ctx.value,
        selected: ctx.selectedItems,
    }));
    const { data, loading, fetchMore } = (0, fdr_lib_apollo_query_1.useQuery)(queryDocument, {
        ssr: false,
        variables: currentVars.current,
        skip: ctx.value.length < minQueryLength,
        onCompleted: onCompleted
            ? completedData => {
                onCompleted(completedData, currentVars.current);
            }
            : undefined,
        onError,
    });
    // It needs update mapped data only on loading == false
    const resultRef = (0, react_1.useRef)(undefined);
    const cacheCounterRef = (0, react_1.useRef)(0);
    const cacheCounter = (0, react_1.useMemo)(() => {
        if (!loading) {
            cacheCounterRef.current += 1;
        }
        return cacheCounterRef.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctx.value]);
    const result = (0, react_1.useMemo)(() => {
        if (!loading) {
            resultRef.current = dataMapper(data);
        }
        return resultRef.current;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, loading, cacheCounter]);
    // Data Page number that is updated by `fetchMore`
    const dataPageNumber = ((_a = result === null || result === void 0 ? void 0 : result.pagination) === null || _a === void 0 ? void 0 : _a.page) || 0;
    // Page number that is managed by autocomplete context
    const ctxPageNumber = ctx.pageNumberExpected;
    // Synchronously call setSuggestion on data changes
    // It should dispatch SET_SUGGESTIONS action
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        const suggestions = (((_a = result === null || result === void 0 ? void 0 : result.items) === null || _a === void 0 ? void 0 : _a.map(suggestionMapper).filter(Boolean)) ||
            []);
        if (suggestions || ctx.suggestions.length !== (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length)) {
            ctx.setSuggestions(suggestions, {
                page: ((_b = result === null || result === void 0 ? void 0 : result.pagination) === null || _b === void 0 ? void 0 : _b.page) || 0,
                total: ((_c = result === null || result === void 0 ? void 0 : result.pagination) === null || _c === void 0 ? void 0 : _c.total) || undefined,
                perPage: ((_d = result === null || result === void 0 ? void 0 : result.pagination) === null || _d === void 0 ? void 0 : _d.perPage) || undefined,
            });
        }
        // Autocomplete Context Handlers are not changing during the time
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctx.value, result === null || result === void 0 ? void 0 : result.items]);
    (0, react_1.useEffect)(() => {
        ctx.setLoading(loading);
        // Autocomplete Context Handlers are not changing during the time
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);
    (0, react_1.useEffect)(() => {
        if (ctxPageNumber <= dataPageNumber)
            return;
        if (ctx.value.length < minQueryLength)
            return;
        fetchMore({
            variables: variablesMapper({
                query: ctx.value,
                selected: ctx.selectedItems,
                page: ctxPageNumber,
            }),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctxPageNumber]);
    return null;
}
exports.FdrAutocompleteDataSource = FdrAutocompleteDataSource;
//# sourceMappingURL=fdr-autocomplete-data-source.js.map